import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconLinkedin = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m18 0h-16c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2zm-12 17h-3v-9h3v9zm-1.5-10.7c-1 0-1.8-0.8-1.8-1.8s0.8-1.8 1.8-1.8 1.8 0.8 1.8 1.8-0.8 1.8-1.8 1.8zm12.5 10.7h-3v-5.3c0-0.8-0.7-1.5-1.5-1.5s-1.5 0.7-1.5 1.5v5.3h-3v-9h3v1.2c0.5-0.8 1.6-1.4 2.5-1.4 1.9 0 3.5 1.6 3.5 3.5v5.7z" />
  </SvgIcon>
);

export default IconLinkedin;



// WEBPACK FOOTER //
// ./src/components/icons/IconLinkedin.js